import { makeStyles } from 'tss-react/mui';

const BORDER = '1px solid rgba(43,45,66,0.1)';

export default makeStyles()(theme => ({
  cardsRow: {
    display: 'flex',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  card: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    background: theme.palette.common.white,
    borderRadius: theme.spacing(),
    padding: theme.spacing(4),
    width: 'calc((100% - 48px) / 3)',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  cardClickable: {
    cursor: 'pointer'
  },
  cardIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cardIconNeutral: {
    background: theme.palette.badge.neutral.bg,
    color: theme.palette.badge.neutral.text
  },
  cardIconInfo: {
    background: theme.palette.badge.info.bg,
    color: theme.palette.badge.info.text
  },
  cardIconOk: {
    background: theme.palette.badge.success.bg,
    color: theme.palette.badge.success.text
  },
  cardIconError: {
    background: theme.palette.badge.error.bg,
    color: theme.palette.badge.error.text
  },
  cardLabel: {
    marginBottom: theme.spacing(1)
  },
  dialogOverline: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.2,
    fontSize: theme.spacing(1.8),
    fontWeight: 500,
    marginBottom: theme.spacing(0.5)
  },
  description: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(3)
  },
  statsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  statTile: {
    flex: 1,
    background: 'rgba(43,45,66,0.03)',
    border: BORDER,
    borderRadius: theme.spacing(),
    padding: theme.spacing(3)
  },
  statLabel: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.2,
    fontSize: theme.spacing(1.8),
    display: 'block',
    marginBottom: theme.spacing(1)
  },
  statValue: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.5)
  },
  statHelper: {
    color: theme.palette.text.primary
  },
  detailSection: {
    border: BORDER,
    borderRadius: theme.spacing(),
    overflow: 'hidden'
  },
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'rgba(43,45,66,0.03)',
    borderBottom: BORDER,
    padding: theme.spacing(2, 3)
  },
  detailTitle: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.2,
    fontSize: theme.spacing(1.8),
    fontWeight: 500
  },
  detailCount: {
    color: theme.palette.text.primary
  },
  tableWrapper: {
    maxHeight: '40vh',
    overflowY: 'auto'
  },
  emptyState: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    padding: theme.spacing(4)
  },
  termMismatch: {
    color: theme.palette.badge.error.text,
    fontWeight: 500
  },
  callout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    background: theme.palette.badge.info.bg,
    color: theme.palette.badge.info.text,
    borderRadius: theme.spacing(),
    padding: theme.spacing(2, 3),
    marginTop: theme.spacing(3)
  },
  calloutIcon: {
    fontSize: theme.spacing(2.5),
    marginTop: theme.spacing(0.25)
  }
}));
